export default {
  CMS_API_PATH: process.env.IN_SYNC_CMS_API_PATH || '/insync/cms'
};
const baseAssignmentApi = '/assignments/api';
const baseAnnotationApi = '/annotations/api';
const jwtToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwbGF0Zm9ybSI6eyJpZCI6ImluLXN5bmMifX0.ipd-Hz3-ra3cMJfN3DCeUZTtKAp5pRhuTDdzObBfDbs'; // We have to send it as jwt token string. I've added it the same than Affirm.
const gmPlatformHeader = {
  'gm-platform': jwtToken
}; // We have to send it as string
export const assignmentInstanceOptions = {
  baseURL: baseAssignmentApi,
  headers: {
    ...gmPlatformHeader
  }
};
export const annotationInstanceOptions = {
  baseURL: baseAnnotationApi,
  headers: {
    ...gmPlatformHeader
  }
};
export const getAssignmentsServiceInstanceOptions = options => ({
  baseURL: baseAssignmentApi,
  headers: {
    ...gmPlatformHeader,
    'enrollment-period': options?.schoolYear
  }
});
export const getAnnotationsServiceInstanceOptions = options => ({
  baseURL: baseAnnotationApi,
  headers: {
    ...gmPlatformHeader,
    'enrollment-period': options?.schoolYear
  }
});